import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-user-panel',
  standalone: false,
  templateUrl: './user-panel.component.html',
  styleUrl: './user-panel.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UserPanelComponent {

}
